/**
 * The hold recovery: when the held time ran out while the client was away, the
 * app's catch-after. Get my time back holds it again (Got it back) or, when it
 * was taken meanwhile, Pick a new time on the offering's page.
 */
import { definePiece } from '../../contract/define';

export const contract = definePiece({
  name: 'hold-recovery',
  description: 'When the held time ran out: Get my time back, then Got it back, or Pick a new time when it was taken.',
  options: {},
  parts: {
    dialog: { description: 'The whole recovery dialog.', required: true },
  },
  actions: {
    recover: { description: 'Holds the same time again, when it is still open.', args: [] },
    repick: { description: 'Goes back to the offering to pick a new time.', args: [] },
  },
  events: {},
});

/** What the hold recovery knows. */
export interface HoldRecoveryState {
  /** none, prompt (it ran out), reheld (Got it back) or taken (pick a new time). */
  readonly phase: 'none' | 'prompt' | 'reheld' | 'taken';
  /** The held time, as the dialog shows it; null when unknown. */
  readonly whenText: string | null;
  /** True while Get my time back is being sent. */
  readonly recovering: boolean;
  /** Why it could not be held again; null otherwise. */
  readonly error: string | null;
}

/** What a drawing can ask the hold recovery to do. */
export interface HoldRecoveryActions {
  /** Hold the same time again. */
  readonly recover: () => void;
  /** Go back to the offering to pick a new time. */
  readonly repick: () => void;
}

/** What the hold recovery tells its host. */
export type HoldRecoveryEvents = Record<string, never>;
